export const PUBLIC_ENDPOINTS = {
  GetRestaurantInfo: 'GetRestaurantInfo.php',
  GetCategories: 'GetCategories.php',
  GetSubCategories: 'GetSubCategories.php',
  GetProducts: 'GetProducts.php',
  GetOpeningHours: 'GetOpeningHours.php',
  GetAnnouncement: 'GetAnnouncement.php',
  SendEmail: 'SendEmail.php',
  SendContactMessage: 'SendContactMessage.php',
  Subscribe: 'Subscribe.php',
  SendFeedback: 'SendFeedback.php',
  Visit: 'Visit.php',
  CheckoutOrder: 'CheckoutOrder.php',
}
